<template>
    <v-avatar size="34">
        <v-icon v-if="conversationtype == 'chat'" color="blue-grey">mdi-chat-alert</v-icon>
        <v-icon v-if="conversationtype == 'sms'" color="blue-grey">mdi-message-alert</v-icon>
        <v-icon v-if="conversationtype == 'notification'" color="blue-grey">mdi-bell-ring</v-icon>
    </v-avatar> 
</template>

<script>
      export default {    
        data() {
            return {
            }
        },
        props: {
            conversationtype: { type: String },
        }
    };
</script>